import {
  NodeViewContent,
  NodeViewWrapper,
  type NodeViewProps,
} from "@tiptap/react";
import humanizeKind from "./humanizeKind";

const SectionNodeView: React.FC<NodeViewProps> = ({ node }) => {
  const kind = node.attrs.kind as string;

  return (
    <NodeViewWrapper
      as="section"
      className="my-6"
      data-section-kind={kind}
    >
      <div
        contentEditable={false}
        className="text-cream-700 dark:text-cream-300 mb-2 font-serif text-lg font-semibold tracking-wide select-none"
      >
        [{humanizeKind(kind)}]
      </div>
      <NodeViewContent className="pl-6 [&_p]:my-1" />
    </NodeViewWrapper>
  );
};

export default SectionNodeView;
